import { PaginationUpdatePayload } from 'features/layout/features/pagination/types';
import { updatePagination } from 'features/layout/pagination/updatePagination';
import { call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

export function* onPaginationSaga(action: PayloadAction<PaginationUpdatePayload>) {
  yield call(updatePagination, action.payload);
}
